let apidaePrestasSearch = {
    props: {
        title: String,
        nbPrestas: Number,
        type: String,
        groupesFiltres: Array,
        lang: String,
        pmin: Number,
        pmax: Number,
        showdate: Number,
        showtarif: Number
    },
    components: {
        groupFilters
    },
    directives: {
        clickaway
    },
    data() {
        return {
            isDropdownActive: false,
        }
    },
    methods: {
        save() {
            this.$root.submitfilters(event)
        },
        // pricevent() {
        //     this.$root.callfilters(event)
        //     this.isDropdownActive = false
        // },
        away() {
            this.isDropdownActive = false;
        }
    },
    template: `
    <div class="sidebar-filter">
        <form class="form" @submit.prevent="save">
            <div class="searchBlockContent">
                <template v-if="groupeFiltres.hide" v-for="(groupeFiltres, index) in groupesFiltres">
                    <group-filters class="cd-filter-block" :groupe-filtres="groupeFiltres"></group-filters>
                </template>
            </div>
        </form>
    </div>`
} 
        // <div class="profile cd-filter-block" :class="{ 'is-active': isDropdownActive }">
        //     <h4 @click="isDropdownActive=!isDropdownActive" :class="(pmin != 0 || pmax != 10000) ? 'selected' : ''">Mon budget</h4>
        //     <div class="cd-filter-content cd-filter-price cd-filters list">
        //         <ul>
        //             <li :class="(pmin == '0' && pmax == '10000') ? 'selected filter' : 'filter'">
        //                 <span @click="pricevent" class="pricevent cd-filter-rbl" data-pmin="0" data-pmax="10000">Tous les prix</span>
        //             </li>
        //             <li :class="(pmin == '0' && pmax == '100') ? 'selected filter' : 'filter'">
        //                 <span @click="pricevent" class="pricevent cd-filter-rbl" data-pmin="0" data-pmax="100">Moins de 100€</span>
        //             </li>
        //             <li :class="(pmin == '100' && pmax == '200') ? 'selected filter' : 'filter'">
        //                 <span @click="pricevent" class="pricevent cd-filter-rbl" data-pmin="100" data-pmax="200">De 100€ à 200€</span>
        //             </li>
        //             <li :class="(pmin == '200' && pmax == '10000') ? 'selected filter' : 'filter'">
        //                 <span @click="pricevent" class="pricevent cd-filter-rbl" data-pmin="200" data-pmax="10000">Supérieur à 200€</span>
        //             </li>
        //         </ul>
        //         <div class="input-number">
        //             <input type="hidden" name="pmin" id="min-number-price" class="min-number autosize" v-model="pmin">
        //             <input type="hidden" name="pmax" id="max-number-price" class="max-number autosize" v-model="pmax">
        //         </div>
        //     </div>
        // </div>

